import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = '/nominas/incidencias-antiguedad-para-enfermedad-general/';

/**
 * GET Incidencias Empleados Incapacidades Medicas
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getIncidenciaAntiguedadesParaEnfermedadesGeneral = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Incidencias Empleados Incapacidad Medica
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getIncidenciaAntiguedadParaEnfermedadGeneral = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Incidencias Empleados Incapacidad Medica
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postIncidenciaAntiguedadParaEnfermedadGeneral = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Incidencias Empleados Incapacidad Medica
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchIncidenciaAntiguedadParaEnfermedadGeneral = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Incidencias Empleados Incapacidad Medica
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteIncidenciaAntiguedadParaEnfermedadGeneral = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Incidencias Empleados Incapacidades Medicas
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarIncidenciaAntiguedadParaEnfermedadGeneral = async (id) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
